import React, { useEffect, useState } from 'react';
import CardHeader from '../shared/CardHeader';
import CardContainer from '../shared/CardContainer';
import { VectorMap } from '@react-jvectormap/core';
import { worldMill } from '@react-jvectormap/world';
import { Box, useTheme } from '@mui/material';
import { formatNumberDE } from '../../../../../../shared/utils/formatNumber';

const MapChart = ({ title = 'N/A', data = {} }) => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.mode === 'dark';
  const [mapKey, setMapKey] = useState(0);
  const mapWidgetData = data;

  useEffect(() => {
    // Update the key when data or theme changes to force re-render
    setMapKey((prevKey) => prevKey + 1);
  }, [mapWidgetData, isDarkTheme]); // Added isDarkTheme as a dependency

  return (
    <CardContainer>
      <CardHeader title={title} />
      <Box sx={{ height: '364px' }}>
        {mapWidgetData ? (
          <VectorMap
            key={mapKey}
            map={worldMill}
            backgroundColor={isDarkTheme ? '#262626' : '#FFFFFF'}
            regionStyle={{
              initial: {
                fill: isDarkTheme ? '#FFFFFF' : '#262626', // Static color for unlisted countries
              },
            }}
            series={{
              regions: [
                {
                  scale: ['#DEEBF7', '#08519C'],
                  values: Object.fromEntries(
                    Object.entries(mapWidgetData).map(([key, value]) => [
                      key,
                      value.effectiveShippedCount,
                    ])
                  ),
                },
              ],
            }}
            onRegionTipShow={function (event, label, code, ...props) {
              const data = mapWidgetData[code] || {
                effectiveShippedCount: 'N/A',
                totalEntries: 'N/A',
              };
              label.html(
                '<div style="background-color: #404040; border: 1px solid #404040; outline: 10px solid #404040; border-radius: 6px; min-height: 70px; width: 150px; color: white; padding-left: 10px">' +
                  '<p>' +
                  '<b>' +
                  label.html() +
                  '</b>' +
                  '</p>' +
                  '<p>' +
                  'Cars: ' +
                  '<b>' +
                  formatNumberDE(data.effectiveShippedCount) +
                  '</b>' +
                  '</p>' +
                  '<p>' +
                  'Ships: ' +
                  '<b>' +
                  formatNumberDE(data.totalEntries) +
                  '</b>' +
                  '</p>' +
                  '</div>'
              );
            }}
          />
        ) : (
          <p>Loading data...</p>
        )}
      </Box>
    </CardContainer>
  );
};

export default MapChart;
